import { BaseModule } from "../../../composition/module/BaseModule";
import { ParamDescription } from "../../../composition/module/ParamDescription";
import { MyBuildingsModuleFlowExecutor } from "./MyBuildingsModuleFlowExecutor";
import { MyBuildingsController } from "./controller/MyBuildingsController";
import { MyBuildingsResourcePackage } from "./resources/MyBuildingsResourcePackage";
import { UpgradeResourcePackage } from "./resources/UpgradeResourcePackage";
import { MyBuildingsPopupScene, MyBuildingsSceneOptions } from "./scenes/MyBuildingsPopupScene";
import { ListInMpNotificationPopupScene } from "../listinmpnotification/ListInMpNotificationPopupScene";
import { ListInMpNotificationController } from "../listinmpnotification/controllers/ListInMpNotificationController";
import { ListInMpNotificationResourcePackage } from "../listinmpnotification/resources/ListInMpNotificationResourcePackage";
import { PriceHistoryResourcePackage } from "../pricehistory/resources/PriceHistoryResourcePackage";
import { PriceHistoryPopupScene } from "../pricehistory/PriceHistoryPopupScene";
import { PurchaseHistory } from "../marketplace/main/models/building/PurchaseHistory";
import { EditPriceModule } from "../editprice/EditPriceModule";

export class MyBuildingsModule extends BaseModule<boolean> {
    private myBuildingsResourcePackage: MyBuildingsResourcePackage;
    private priceHistoryResourcePackage: PriceHistoryResourcePackage;
    private upgradeResourcePackage: UpgradeResourcePackage;
    private listInNotificationResources: ListInMpNotificationResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(MyBuildingsModuleFlowExecutor, MyBuildingsModuleFlowExecutor);

        this.internalContainer.register("IMyBuildingsController", MyBuildingsController);
        this.internalContainer.register(MyBuildingsPopupScene, MyBuildingsPopupScene);
        this.internalContainer.register("MyBuildingsPopupSceneFactory", {
            useValue: async (sceneOptions: MyBuildingsSceneOptions) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    MyBuildingsPopupScene,
                    new ParamDescription("MyBuildingsSceneOptions", sceneOptions)
                );
            }
        });

        this.registerModule(EditPriceModule);

        this.myBuildingsResourcePackage = new MyBuildingsResourcePackage();
        await this.myBuildingsResourcePackage.load();
        this.internalContainer.registerInstance(MyBuildingsResourcePackage, this.myBuildingsResourcePackage);

        this.upgradeResourcePackage = new UpgradeResourcePackage();
        await this.upgradeResourcePackage.load();
        this.internalContainer.registerInstance(UpgradeResourcePackage, this.upgradeResourcePackage);

        this.listInNotificationResources = new ListInMpNotificationResourcePackage();
        await this.listInNotificationResources.load();
        this.internalContainer.registerInstance(ListInMpNotificationResourcePackage, this.listInNotificationResources);

        this.internalContainer.register(ListInMpNotificationPopupScene, ListInMpNotificationPopupScene);
        this.internalContainer.register("IListInMpNotificationController", ListInMpNotificationController);

        this.priceHistoryResourcePackage = new PriceHistoryResourcePackage();
        await this.priceHistoryResourcePackage.load();
        this.internalContainer.registerInstance(PriceHistoryResourcePackage, this.priceHistoryResourcePackage);
        this.internalContainer.register(PriceHistoryPopupScene, PriceHistoryPopupScene);
        this.internalContainer.register("PriceHistoryPopupSceneFactory", {
            useValue: async (priceHistory: Array<PurchaseHistory>) => {
                return await this.resolveWithParams(
                    this.internalContainer,
                    PriceHistoryPopupScene,
                    new ParamDescription(Array<PurchaseHistory>, priceHistory)
                );
            }
        });

        await super.build();
    }

    public async start(): Promise<boolean> {
        const executor = await this.internalContainer.resolve(MyBuildingsModuleFlowExecutor);
        const result = await executor.execute(this);
        this.dispose();
        return result;
    }

    public override dispose(): void {
        this.myBuildingsResourcePackage.destroy();
        this.upgradeResourcePackage.destroy();
        this.listInNotificationResources.destroy();
        this.priceHistoryResourcePackage.destroy();
        super.dispose();
    }
}
